<template>
  <div>
    <hr />
    <div
      class="search__results__filter is-flex is-justify-content-center is-align-content-center"
    >
      <div
        class="search__results__filter__overlay"
        :class="{ open: filtersOpen }"
      >
        <div class="columns is-multiline mt-1">
          <div class="column column is-one-third pr-5 is-align-content-start">
            <span class="search__results__filter__title">{{
              $t("searchFilters.hotelNameOrChainTitle")
            }}</span>
            <input
              id="hotelName"
              type="text"
              :placeholder="$t('searchFilters.hotelNameOrChain')"
              v-model="filters.hotelName"
            />
          </div>
          <div class="column is-one-third">
            <div class="search__results__filter__wrapper--greenkey">
              <GreenKeyFilter
                :initialValue="filters.greenKey"
                @greenKeyChanged="greenKeyChanged"
              />
            </div>
            <div class="search__results__filter__wrapper--score">
              <RatingFilter
                :initialValue="filters.score"
                @ratingChanged="ratingChanged"
              />
            </div>
          </div>
          <div class="column is-one-third">
            <AmenitiesFilter
              :initialValue="filters.amenities"
              @amenitiesChanged="amenitiesChanged"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingFilter from "./RatingFilter.vue";
import AmenitiesFilter from "./AmenitiesFilter.vue";
import GreenKeyFilter from "./GreenKeyFilter.vue";

import CommonHelper from "@/helpers/common.helper";
import FilterHelper from "@/helpers/filters.helper.js";
import moment from "moment";

export default {
  name: "Filters",
  components: {
    RatingFilter,
    AmenitiesFilter,
    GreenKeyFilter
    //RefundableFilter
  },
  props: {
    filtersOpen: Boolean,
    location: {},
    variables: {}
  },
  data() {
    return {
      date: null,
      arrivalDate: new Date(),
      departureDate: new Date(),
      minDepartureDate: new Date(),
      filters: {
        radius: 10,
        stars: {},
        hotelName: "",
        score: {},
        adults: 1,
        rooms: 1,
        refundable: true,
        greenKey: false,
        amenities: {},
        checkin: null,
        nights: 1
      },
      locationPath: ""
    };
  },
  methods: {
    handleDate(date) {
      const [startDate, endDate] = date;
      let nights = moment(endDate).diff(moment(startDate), "days") + "";
      if (nights == 0) nights = 1;

      this.filters.checkin = startDate;
      this.filters.nights = nights;
    },
    getDateRange() {
      let dateRange = CommonHelper.getDateRange(
        this.variables.checkin,
        this.variables.nights
      );
      return dateRange;
    },
    openFilters() {
      this.$emit("toggleFilters");
    },
    closeFilters() {
      this.$emit("closeFilters");
    },
    applyFilters() {
      this.$emit("applyFilters", this.filters);
    },
    amenitiesChanged(amenities) {
      this.filters.amenities = amenities;
    },
    ratingChanged(score) {
      this.filters.score = score;
    },
    hasRefundableChanged(refundable) {
      this.filters.refundable = refundable;
    },
    starsChanged(stars) {
      this.filters.stars = stars;
    },
    greenKeyChanged(greenKey) {
      this.filters.greenKey = greenKey;
    },
    selectedLocation(locationPath) {
      this.locationPath = locationPath;
      this.$emit("selectedLocation", locationPath);
    },
    setDateForInput() {
      const range = this.getDateRange();
      const selectedDate = [range.startDate, range.endDate];
      this.date = selectedDate;
    }
  },
  watch: {
    filtersOpen: {
      immediate: true,
      handler(newValue, oldValue) {
        this._suppressWatch = true;
        this.setDateForInput();
        this.filters.nights = this.variables.nights;
        this.$nextTick(() => {
          this._suppressWatch = false;
        });
      }
    },
    filters: {
      deep: true,
      handler() {
        if (this._suppressWatch) return;
        clearTimeout(this._applyTimeout);
        this._applyTimeout = setTimeout(() => {
          this.applyFilters();
        }, 400);
      }
    }
  },
  mounted() {},
  created: function () {
    const v = this.variables || {};

    // Reverse-map reviewScore array → score object
    const numberToKey = {
      5: "five",
      6: "six",
      7: "seven",
      8: "eight",
      9: "nine"
    };
    const scoreArr = v.reviewScore || [];
    const score =
      scoreArr.length === 0
        ? { five: true, six: true, seven: true, eight: true, nine: true }
        : Object.fromEntries(
            ["five", "six", "seven", "eight", "nine"].map((k) => [k, false])
          );
    if (scoreArr.length > 0)
      scoreArr.forEach((n) => {
        if (numberToKey[n]) score[numberToKey[n]] = true;
      });

    // Reverse-map amenities array → amenities object
    const amenityArr = v.amenities || [];
    const amenities = {};
    FilterHelper.getPrimeAmenities().forEach((a) => {
      amenities[a.name] = amenityArr.includes(a.name);
    });

    // Reverse-map stars array → stars object
    const starsArr = v.stars || [];
    const stars = {
      oneStars: starsArr.includes(1),
      twoStars: starsArr.includes(2),
      threeStars: starsArr.includes(3),
      fourStars: starsArr.includes(4),
      fiveStars: starsArr.includes(5)
    };

    this._suppressWatch = true;
    this.filters = {
      radius: v.radius ?? 10,
      stars,
      hotelName: v.hotelName || "",
      score,
      adults: v.adults ?? 1,
      rooms: v.rooms ?? 1,
      refundable: v.refundable ?? true,
      greenKey: v.greenKey ?? false,
      amenities,
      checkin: v.checkin || null,
      nights: v.nights ?? 1
    };
    this.$nextTick(() => {
      this._suppressWatch = false;
    });
  }
};
</script>
